import { UsersDataSourceUID } from "@ehealth_tools/common/src/data/user/user.ds";
import { I18nBooking } from "./booking.i18n";
import { _SAFE_SHARING } from "./booking.types";

export enum BookingDataSourceUID {
    BOOKING_MODALITY = "BOOKING_MODALITY",
    ADVERTISEMENT = "ADVERTISEMENT",
    CIVILITY = UsersDataSourceUID.CIVILITY

}

export enum BOOKING_MODALITY {
    LOCAL = 1,
    VISIO
}
export const BOOKING_MODALITY_DATA = [
    { id: BOOKING_MODALITY.LOCAL, name: I18nBooking().datasources.modality.local },
    { id: BOOKING_MODALITY.VISIO, name: I18nBooking().datasources.modality.visio }
];

export const BOOKING_ADVERTISEMENT_DATA = [
    { id: _SAFE_SHARING.NONE, name: I18nBooking().datasources.advertisement.none },
    { id: _SAFE_SHARING.TIMESLOT_ONLY, name: I18nBooking().datasources.advertisement.timeslot }
];